import React, { CSSProperties, HTMLInputTypeAttribute } from "react";

export interface LabeledTextareaProps {
    label : String,
    placeholder?: any,
    maxLength: number,
    value?: any,
    name?: any
}

const INPSTYLES: CSSProperties = {
    borderRadius: 10,
    border: "2px solid black",
    padding: ".5rem",
    fontSize: 14,
    resize: "vertical",
    fontFamily: 'Poppins',
    fontWeight: 200,
}

const LABELSTYLES = {
    fontFamily: '"Poppins" sans-serif',
    margin: ".5rem 0",
    fontSize: 14,
}

const LabeledTextarea: React.FC<LabeledTextareaProps> = LabeledTextareaProps => {
    return (
        <>
            <label style={LABELSTYLES}>
                {LabeledTextareaProps.label}
            </label>
            <textarea
                name={LabeledTextareaProps.name}
                style={INPSTYLES}
                maxLength={LabeledTextareaProps.maxLength}
            />
        </>
    )
}

export {
    LabeledTextarea
}